export default { tag: 'client@2.25.0' };